import { BrandListRequestOption } from '../../../types/brand/list';
import SuperFetchV2 from '../../superFetchV2';
import qs from 'query-string';
import { BrandsExcelUploadResponseDto, BrandsFindResponseBodyBrandDto } from '../../../types/api/brands';

const BrandApiV2 = {
  getBrandList: async (
    option: BrandListRequestOption,
  ): Promise<{ totalCount: number; brands: BrandsFindResponseBodyBrandDto[] }> => {
    return SuperFetchV2.get(`/brands?${qs.stringify(option, { skipNull: true, skipEmptyString: true })}`);
  },
  uploadExcel: (file: File): Promise<BrandsExcelUploadResponseDto> => {
    const formData = new FormData();
    formData.append('file', file);
    return SuperFetchV2.post('/brands/excel-upload', formData);
  },
  downloadExcel: (brandIdList: number[]): Promise<{ adminEmail: string }> =>
    SuperFetchV2.post('/brands/excel-download', { brandIds: brandIdList }),
};

export default BrandApiV2;
